import React from "react";
import { Container } from "react-bootstrap";
import styled from "styled-components";

const SectionWrapper = styled.div`
  padding: 2rem;

  .container {
    h2 {
      text-align: center;
      padding: 1.5rem;
      text-transform: none;
      font-family: "Open Sans", sans-serif;
    }

    h3 {
      padding: 1rem 0;
      font-family: "Open Sans", sans-serif;
    }

    a {
      color: #535c66;

      &:hover {
        color: #292e33;
        -webkit-font-smoothing: antialiased;
        text-decoration: none;
      }

      &:focus {
        color: #292e33;
      }
    }

    a.btn {
      color: #fff;
    }

    a.alert {
      color: #000;
    }

    div.ghost-text {
      a {
        color: #6fa4d9;

        &:hover {
          color: #6290bf;
          -webkit-font-smoothing: antialiased;
          text-decoration: none;
        }

        &:focus {
          color: #4e7499;
        }
      }
    }
  }
`;

const Section = ({ bgColor = "", textColor = "", title, children }) => {
  return (
    <SectionWrapper className={`${bgColor} ${textColor}`.trim()}>
      <Container>
        {title && <h2>{title}</h2>}
        {children}
      </Container>
    </SectionWrapper>
  );
};

export default Section;